import { matchSorter } from 'match-sorter';
import type { MatchSorterOptions } from 'match-sorter';
import type { SocialProfileType } from '@/types/socialProfileType';
import type { SpGroupType } from '@/utils/hooks/swr/group/useSPGroups';

export const sortKeyProfile: MatchSorterOptions<SocialProfileType> = {
    threshold: matchSorter.rankings.CONTAINS,
    keys: ['slug', 'social_network_type', 'external_api_data.name']
};

export const sortKeyGroup: MatchSorterOptions<SpGroupType> = {
    threshold: matchSorter.rankings.CONTAINS,
    keys: ['name']
};
